export interface LetterProps {
  page: number;
  letter: string;
  letterId: string;
  activityLetter: string;
  word?: string;
}

export enum ActivityPageTypes {
  FIRST_PAGE = 'firstPage',
  SECOND_PAGE = 'secondPage',
}

export enum LetterConstants {
  CORRECT = 'correct',
  WRONG = 'wrong',
}
